import { _pejerProvider, defaultPejerState, usePejerBase } from 'pejer/src/stores/pejerData'
import { PejerPay } from './PejerPay'
import { config } from './config'

const pejer = new PejerPay({
  ...defaultPejerState,
  data: {},
})

export const pejerProvider = () => _pejerProvider(pejer as any, config)

export const usePejer = () => {
  const pejer = usePejerBase() as PejerPay
  if (!pejer.config) throw new Error('Pejer config not set')

  return pejer
}

export { config }
